import Bowser from "bowser";
import { useEffect, useState } from "react";

const getFingerprint = () => {
  const browser = Bowser.getParser(window.navigator.userAgent).getBrowserName();
  const os = Bowser.getParser(window.navigator.userAgent).getOSName();

  return {
    screenResolution: `${window.screen.width}x${window.screen.height}`,
    platform: navigator.platform,
    hardwareConcurrency: navigator.hardwareConcurrency || "N/A",
    colorDepth: window.screen.colorDepth,
    browser,
    os,
  };
};
const hashFingerprint = async (fingerprint: object) => {
  const encoder = new TextEncoder();
  const data = encoder.encode(JSON.stringify(fingerprint));
  const hashBuffer = await crypto.subtle.digest("SHA-256", data);
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  return hashArray.map((byte) => byte.toString(16).padStart(2, "0")).join("");
};

export const useFingerprint = () => {
  const [fingerprintHash, setFingerprintHash] = useState<string | null>(null);

  useEffect(() => {
    const generateFingerprint = async () => {
      const fingerprint = getFingerprint();
      const hash = await hashFingerprint(fingerprint);
      setFingerprintHash(hash);
    };

    generateFingerprint();
  }, []);

  return fingerprintHash;
};
